import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject } from './form-data.utility';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

export const filterPVModuleModelsHook = (): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const p = field.parent;
    const mfgObj = getChildObject(p, 'pvmoduleManufacturer');
    const mfgFormField = field.form.get(mfgObj.key);

    const modelObj = getChildObject(p, 'pvmoduleModel');

    field.props.options = mfgFormField.valueChanges.pipe(
      startWith(`${mfgFormField.value}:initial`),
      tap((value) => {
        if (field.form.status === 'DISABLED') {
          field.form.get(modelObj.key).disable();
        }
        if (field.form.status !== 'DISABLED') {
          const model = field.form.get(modelObj.key);
          const isStartValue =
            value === null ? false : value?.toString().split(':').length > 1;
          if (!isStartValue) {
            model.setValue('');
          }
          
          const ratedDCkWObj = getChildObject(p, 'inverterDCRatedVoltage');
          const ratedDCkW = field.form.get(ratedDCkWObj.key);
          if (!isStartValue) {
            ratedDCkW.setValue('');
          }
        }
      }),
      switchMap((mfg) => {
        if (mfg?.toString().includes(':initial')) {
          mfg = mfg.replace(':initial', '');
        }
        const filteredPVModuleModels = field.options.formState.pvModules.filter(
          (pvmm) => pvmm.manufacturer === mfg
        );
        if (filteredPVModuleModels.length > 0) {
          const options = filteredPVModuleModels.map((pvmm) => {
            return {
              value: pvmm.modelNumber,
              label: pvmm.modelNumber,
            };
          });
          const distinctOptions = new Map();
          options.forEach(option => {
            distinctOptions.set(option.value, option);
          });
          return of(Array.from(distinctOptions.values()));
        } else {
          return of([]);
        }
      })
    );
  };
};
